require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./brand-design-lorelei.json") })
        }
      }, "path---brand-design-lorelei");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---brand-design-lorelei!./.cache/json/brand-design-lorelei.json
// module id = 375
// module chunks = 231608221292675